import { useContext } from '@nuxtjs/composition-api';

export function useMainSiteLink (): string {
  const { $config } = useContext();

  return `//${ $config.MAIN_SITE_HOST }`;
}
